import React, { useState, useEffect } from "react";
import { Menu, X, Phone } from "lucide-react";
import { LogoLockup } from "@/components/Logo";
import EmergencyBanner from "@/components/EmergencyBanner";
import { CONTACT } from "@/data/content";

const NAV = [
  { label: "Services", href: "#services" },
  { label: "About", href: "#about" },
  { label: "Insurance", href: "#insurance" },
  { label: "Reviews", href: "#testimonials" },
  { label: "Service Area", href: "#area" },
];

export const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div className="fixed top-0 left-0 right-0 z-50">
      <EmergencyBanner />
      <header
        data-testid="site-header"
        className={`transition-all duration-300 ${
          scrolled
            ? "bg-white/90 backdrop-blur-xl border-b border-[#E5E7EB] py-3"
            : "bg-[#0A0A0A]/40 backdrop-blur-sm py-4"
        }`}
      >
      <div className="container mx-auto px-6 md:px-12 max-w-7xl flex items-center justify-between">
        <a href="#top" data-testid="header-logo">
          <LogoLockup inverted={!scrolled} />
        </a>

        <nav className="hidden lg:flex items-center gap-8">
          {NAV.map((n) => (
            <a
              key={n.href}
              href={n.href}
              data-testid={`nav-${n.label.toLowerCase().replace(/\s/g, "-")}`}
              className={`font-heading text-sm font-semibold uppercase tracking-wide hover:text-[#D86C1E] transition-colors ${
                scrolled ? "text-[#0A0A0A]" : "text-white"
              }`}
            >
              {n.label}
            </a>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-4">
          <a
            href={`tel:${CONTACT.phoneRaw}`}
            data-testid="header-phone"
            className={`flex items-center gap-2 font-heading font-bold hover:text-[#D86C1E] transition-colors ${
              scrolled ? "text-[#0A0A0A]" : "text-white"
            }`}
          >
            <Phone className="h-4 w-4 text-[#D86C1E]" />
            {CONTACT.phone}
          </a>
          <a
            href="#quote"
            data-testid="header-quote-btn"
            className="bg-[#D86C1E] hover:bg-[#B0551A] text-white font-heading font-bold text-sm uppercase tracking-wide px-5 py-3 transition-all hover:-translate-y-0.5 shadow-md hover:shadow-lg"
          >
            Free Quote
          </a>
        </div>

        <button
          onClick={() => setOpen(!open)}
          data-testid="mobile-menu-toggle"
          className={`lg:hidden ${scrolled ? "text-[#0A0A0A]" : "text-white"}`}
          aria-label="Toggle menu"
        >
          {open ? <X className="h-7 w-7" /> : <Menu className="h-7 w-7" />}
        </button>
      </div>

      {open && (
        <div
          data-testid="mobile-menu"
          className="lg:hidden bg-white border-t border-[#E5E7EB] px-6 py-6 flex flex-col gap-4"
        >
          {NAV.map((n) => (
            <a
              key={n.href}
              href={n.href}
              onClick={() => setOpen(false)}
              className="font-heading font-semibold uppercase tracking-wide text-[#0A0A0A]"
            >
              {n.label}
            </a>
          ))}
          <a
            href={`tel:${CONTACT.phoneRaw}`}
            className="flex items-center gap-2 font-heading font-bold text-[#0A0A0A]"
          >
            <Phone className="h-4 w-4 text-[#D86C1E]" /> {CONTACT.phone}
          </a>
          <a
            href="#quote"
            onClick={() => setOpen(false)}
            className="bg-[#D86C1E] text-white text-center font-heading font-bold uppercase tracking-wide px-5 py-3"
          >
            Free Quote
          </a>
        </div>
      )}
      </header>
    </div>
  );
};

export default Header;
